module.exports = __webpack_public_path__ + "static/metrics-hero-2-554d64e5226e2866447fc7d1f7aeb1be.png";